import { render, staticRenderFns } from "./FieldText.vue?vue&type=template&id=2309cc54&scoped=true"
import script from "./FieldText.vue?vue&type=script&lang=ts"
export * from "./FieldText.vue?vue&type=script&lang=ts"
import style0 from "./FieldText.vue?vue&type=style&index=0&id=2309cc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2309cc54",
  null
  
)

export default component.exports